export interface EvmMulticallResponse {
    success: boolean;
    returnData: string;
}
